export interface IQuery { }

export class CapexAccountByIdQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Capex.Queries.CapexAccountByIdQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	CapexId: string

	constructor (workspaceId: number, strategyId: string, capexId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.CapexId = capexId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Capex.Queries.CapexAccountByIdQueryV1, TCh.Domain.Quest'
	}

}

export class CapexAccountsByPortfolioIdQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Capex.Queries.CapexAccountsByPortfolioIdQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string

	constructor (workspaceId: number, portfolioId: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Capex.Queries.CapexAccountsByPortfolioIdQueryV1, TCh.Domain.Quest'
	}

}

export class CapexAccountsByStrategyIdQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Capex.Queries.CapexAccountsByStrategyIdQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Capex.Queries.CapexAccountsByStrategyIdQueryV1, TCh.Domain.Quest'
	}

}

